/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
/*
 * AppConstants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here. We prefix them with 'yourproject/YourComponent' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'yourproject/YourContainer/YOUR_ACTION_CONSTANT';
 */

enum ActionTypes {
  RESET_STATE = 'gfm/usuarios/RESET_STATE',
  // Set reducer
  SET_PERFILES_USUARIO = 'gfm/usuarios/SET_PERFILES_USUARIO',
  SET_INFO_USERS = 'gfm/usuarios/SET_INFO_USERS',
  // Requests
  GET_PERFILES_USUARIO_REQUEST = 'gfm/usuarios/GET_PERFILES_USUARIO_REQUEST',
  GET_INFO_USERS_REQUEST = 'gfm/usuarios/GET_INFO_USERS_REQUEST',
  // Requests status
  SET_GET_PERFILES_USUARIO_REQUEST_STATUS = 'gfm/usuarios/SET_GET_PERFILES_USUARIO_REQUEST_STATUS',
  SET_GET_INFO_USERS_REQUEST_STATUS = 'gfm/usuarios/SET_GET_INFO_USERS_REQUEST_STATUS',
  //  User photo
  POST_UPDATE_CONSENT = 'gfm/usuarios/POST_UPDATE_CONSENT',
  SET_POST_UPDATE_CONSENT = 'gfm/usuarios/SET_POST_UPDATE_CONSENT',
  GET_USER_PORTRAIT_REQUEST = 'gfm/usuarios/GET_USER_PORTRAIT_REQUEST',
  SET_USER_PORTRAIT_REQUEST = 'gfm/usuarios/SET_USER_PORTRAIT_REQUEST',
  SET_USER_PORTRAIT_DATA_REQUEST = 'gfm/usuarios/SET_USER_PORTRAIT_DATA_REQUEST',
  GET_ALUMN_PORTRAIT_REQUEST = 'gfm/usuarios/GET_ALUMN_PORTRAIT_REQUEST',
  SET_ALUMN_PORTRAIT_REQUEST = 'gfm/usuarios/SET_ALUMN_PORTRAIT_REQUEST',
  UPDATE_USER_PORTRAIT_REQUEST = 'gfm/usuarios/UPDATE_USER_PORTRAIT_REQUEST',
  UPDATE_USER_PORTRAIT_REQUEST_STATUS = 'gfm/usuarios/UPDATE_USER_PORTRAIT_REQUEST_STATUS',
  DELETE_USER_PORTRAIT_REQUEST = 'gfm/usuarios/DELETE_USER_PORTRAIT_REQUEST',
  DELETE_USER_PORTRAIT_REQUEST_STATUS = 'gfm/usuarios/DELETE_USER_PORTRAIT_REQUEST_STATUS',

  //Filtros
  GET_FILTROS = 'gfm/usuarios/GET_FILTROS',
  SET_FILTROS = 'gfm/usuarios/SET_FILTROS',
  SET_FILTRO_ID = 'gfm/usuarios/SET_FILTRO_ID',
  SET_FILTRO_JSON = 'gfm/usuarios/SET_FILTRO_JSON',
  SET_FILTRO_NOMBRE_PAGINA = 'gfm/usuarios/SET_FILTRO_NOMBRE_PAGINA',
  SET_FILTRO_NOMBRE = 'gfm/usuarios/SET_FILTRO_NOMBRE',
  SET_FILTRO_FECHA_CREACION = 'gfm/usuarios/SET_FILTRO_FECHA_CREACION',
  SET_FILTRO_FECHA_MODIFICACION = 'gfm/usuarios/SET_FILTRO_FECHA_MODIFICACION',
  ELIMINAR_FILTRO_REQUEST = 'gfm/usuarios/ELIMINAR_FILTRO_REQUEST',
  SET_ELIMINAR_FILTRO_REQUEST_STATUS = 'gfm/usuarios/SET_ELIMINAR_FILTRO_REQUEST_STATUS',
  SET_GUARDAR_FILTRO_REQUEST_STATUS = 'gfm/usuarios/SET_GUARDAR_FILTRO_REQUEST_STATUS',
  SET_EDITAR_FILTRO_REQUEST_STATUS = 'gfm/usuarios/SET_EDITAR_FILTRO_REQUEST_STATUS',
  GUARDAR_FILTRO_REQUEST = 'gfm/usuarios/GUARDAR_FILTRO_REQUEST',
  EDITAR_FILTRO_REQUEST = 'gfm/usuarios/EDITAR_FILTRO_REQUEST',
  SET_CURSOS_FILTRO = 'gfm/usuarios/SET_CURSOS_FILTRO',
  SET_SOCIEDADES_FILTRO = 'gfm/usuarios/SET_SOCIEDADES_FILTRO',
  SET_SOCIEDADES = "gfm/usuarios/SET_SOCIEDADES",
  GET_FILTROS_REQUEST = "gfm/usuarios/GET_FILTROS_REQUEST",
  SET_GET_FILTROS_REQUEST_STATUS = "gfm/usuarios/SET_GET_FILTROS_REQUEST_STATUS",
  REMOVE_FILTRO = "gfm/usuarios/REMOVE_FILTRO",


  //panel administracion

  GET_ALL_USUARIOS = "gfm/usuarios/GET_ALL_USUARIOS",
  SET_ALL_USUARIOS = "gfm/usuarios/SET_ALL_USUARIOS",
  SET_GET_ALL_USUARIOS_REQUEST_STATUS = "gfm/usuarios/SET_GET_ALL_USUARIOS_REQUEST_STATUS",
  INSERTAR_USUARIO_PERFIL = "gfm/usuarios/INSERTAR_USUARIO_PERFIL",
  SET_INSERTAR_USUARIOS_PERFIL_REQUEST_STATUS = "gfm/usuarios/SET_INSERTAR_USUARIOS_PERFIL_REQUEST_STATUS",
  HABILITAR_USUARIO_PERFIL = "gfm/usuarios/HABILITAR_USUARIO_PERFIL",
  SET_HABILITAR_USUARIO_PERFIL_REQUEST_STATUS = "gfm/usuarios/SET_HABILITAR_USUARIOS_PERFIL_REQUEST_STATUS",
  ELIMINAR_USUARIO_PERFIL = "gfm/usuarios/ELIMINAR_USUARIO_PERFIL",
  SET_ELIMINAR_USUARIOS_PERFIL_REQUEST_STATUS = "gfm/usuarios/SET_ELIMINAR_USUARIOS_PERFIL_REQUEST_STATUSRFIL",

}

export default ActionTypes;
